import React, { useEffect, useState } from "react";
import {
  transformResultsToCompProfileData,
  formatBoldText,
} from "../../../../../services/commonService";
import InsightTable from "../../InsightTable";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function TechnologyCapabilityAssessment({ technologyCapabilityAssessment }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");
  const allMetrics = [
    // { key: "technology_parameter", label: "Technology Area" },
    { key: "current_state", label: "Current State" },
    // { key: "strategic_priority", label: "Strategic Priority" },
  ];

  const dummyData = [
    {
      technology_area: {
        value: "HealthTech Inc.",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.85,
        reasoning: "Derived from partner onboarding documentation.",
      },
      technology_area_positive_insight: {
        value: "Rapid scaling across regions.",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.85,
        reasoning: "Growth tracked in Q2 rollout.",
      },
      technology_area_negative_insight: {
        value: "Limited to U.S. market.",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.75,
        reasoning: "No expansion outside U.S. to date.",
      },
      technology_area_recent_development: {
        value: "New product version launched in July.",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.8,
        reasoning: "Based on vendor press release.",
      },

      current_state: {
        value: "EHR Systems",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.8,
        reasoning: "Based on vendor product classification.",
      },
      current_state_positive_insight: {
        value: "Strong reputation in mid-market.",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.85,
        reasoning: "Customer satisfaction surveys.",
      },
      current_state_negative_insight: {
        value: "Limited to acute care settings.",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.7,
        reasoning: "No ambulatory offerings available.",
      },
      current_state_recent_development: {
        value: "Expanded features to cover surgical workflows.",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.8,
        reasoning: "Confirmed in feature update report.",
      },

      strategic_priority: {
        value: "High",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.9,
        reasoning: "Measured by deployment across all departments.",
      },
      strategic_priority_positive_insight: {
        value: "Fully integrated across EMR and billing.",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.85,
        reasoning: "Feedback from implementation teams.",
      },
      strategic_priority_negative_insight: {
        value: "Integration delays in 2 sites.",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.7,
        reasoning: "Deployment status reports.",
      },
      strategic_priority_recent_development: {
        value: "Resolved API issues in July.",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.75,
        reasoning: "Engineering resolution ticket logged.",
      },
    },
  ];

  useEffect(() => {
    setTabData(dummyData);
    const transformed = transformResultsToCompProfileData(
      technologyCapabilityAssessment
    );
    setTabData(transformed);

    setTableBelowDescription(
      // formatBoldText(
      //   technologyCapabilityAssessment?.[0]?.response?.[
      //     "technology_capability_summary"
      //   ]
      // )
      <ParsedTextWithLinks
        text={
          technologyCapabilityAssessment?.[0]?.response?.[
            "technology_capability_summary"
          ] || ""
        }
      />
    );
  }, [technologyCapabilityAssessment]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <div className="tech_capability_wrapper">
      <InsightTable
        title="Technology Capability Assessment"
        subtitle={`Observable operational foundation and competitive infrastructure`}
        data={tabData}
        metrics={allMetrics}
        rowIdentifier="technology_parameter"
        belowTableDescription={tableBelowDescription}
        actions={actions}
      />
    </div>
  );
}

export default TechnologyCapabilityAssessment;
